import {useMutation} from "@tanstack/react-query";
import {createOfferTemplateMutationOptions} from "./create-offer-template.mutation-options";

export function useCreateOfferTemplate() {
  return useMutation(createOfferTemplateMutationOptions());
}
